import React from 'react';
import { Box } from '@mui/material';
import { ReadingsTab } from './ReadingsTab';
import { CanvasesTab } from './CanvasesTab';
import { PapersTab } from './PapersTab';

interface ResourceManagementTabsProps {
  activeTab: string;
}

export const ResourceManagementTabs: React.FC<ResourceManagementTabsProps> = ({
  activeTab,
}) => {
  return (
    <Box sx={{ pt: 2 }}>
      {activeTab === 'readings' && <ReadingsTab />}
      {activeTab === 'canvases' && <CanvasesTab />}
      {activeTab === 'papers' && <PapersTab />}
    </Box>
  );
};
